<template>

	<div id="header">

		<header class="app-header">
			<router-link to="/">
				<img v-bind:src="config.logo" class="app-logo" />
			</router-link>

			<!--<span class="pull-right session-expires" @mouseover="setTokenExpiration()">
				<el-tooltip class="item" effect="dark" :content="session_msg" placement="left">
					<el-button type="text" size="large" :style="'color:' + session_icon_color" icon="time"></el-button>
				</el-tooltip>			
			</span>-->

			<el-dropdown class="avatar-menu" @command="handleCommand">
				<avatar :size="37" :username="userGreeting" class="user-avatar"></avatar>

				<el-dropdown-menu slot="dropdown">
					<el-dropdown-item>Hi, {{userGreeting}}</el-dropdown-item>
					<el-dropdown-item divided command="toProfile">Profile</el-dropdown-item>
					<el-dropdown-item command="logout">Logout</el-dropdown-item>
				</el-dropdown-menu>
			</el-dropdown>

			<span class="current-time" v-text="current_time"></span>
    </header>

	</div>

</template>

<script>
	import Config from '@/store/Config.js';
	import Utils from '@/components/utils/Utils.js';
	import Interface from '@/store/Interface.js';
	import Auth from '@/components/auth/AuthCheck.js';
	import Avatar from 'vue-avatar';
  import moment from 'moment';
  import store from '@/store/Store.js';

  export default {
		components: {
			Avatar
		},

		data() {
			return {
        config: Config.config,
        permissions: store.permissions,
        user: store.user,
        
				nav_collapsed: Interface.state.nav_collapsed,
        current_time: null,
        
				jwt: {}
			};
		},

		computed: {
			userGreeting: function() {
				const me  = this;
				return me.jwt.firstName + ' ' + me.jwt.lastName;
			}
		},
		
		mounted: function() {
      const me  = this;

      me.jwt = Utils.decodejwt();

      me.getUserDetails();
			me.setTokenExpiration();
		},

		created() {
			const me  = this;
			me.current_time = moment().format(me.config.date_format_timestamp);
			setInterval(() => this.updateCurrentTime(), 1 * 1000);
		},

    methods: {
			getUserDetails: function() {
        console.log('(Header) Get User Details Function');
        const me = this;
        
        me.permissions.user_roles = _.concat(me.jwt.access_level, me.jwt.roles);

        me.$http.get(me.config.api + 'user/{id}', {params: {id: me.jwt.sub}}).then(
          response => {
          console.log('(Header) Get User Details Function - Success Getting Data');
          
          me.user.data = response.body.data;       
        }, response => {
          console.log('(Header) Get User Details Function - Error Getting Data');
        });
	  },
	  
			handleCommand: function(command) {
				console.log('(Header) Handle Command Function');
        const me = this;
        
				me[command]();
				// console.log('Command', command);
			},

			//Log out
			logout(){
				console.log('(Header) Log Out Function');
				const me = this;
				Auth.logout(me);
			},

			toProfile() {
				const me = this;
				me.$router.push({ name: 'UserEdit', params: { id: me.jwt.sub }})
			},

			// Set the token expiration time
			setTokenExpiration: function() {
				const me = this;
        console.log('(Header) Set Token Expiration Function');
        
				var jwt = Utils.decodejwt(me, 'login');
				var currentTime = Date.now();
				var expTime = jwt.exp;
				var countdown = ((expTime - currentTime / 1000) / 60);
				var sessionEnd = Math.round(countdown);
				// console.log('🕔 Session ends in', sessionEnd, 'minutes');
				if (sessionEnd >= 0) {
					me.session_msg = 'Your login session ends in ' + sessionEnd + ' minutes';
					me.session_icon_color = '#20A0FF';
				} else {
					me.session_msg = 'Your login session has expired - please log in again';
					me.session_icon_color = '#F7BA2A';
				}
			},
			
			updateCurrentTime() {
				const me = this;
				me.current_time = moment().format(me.config.date_format_timestamp);
			}
		}
  }
</script>

<style scoped>

	.app-header {
		/* background-color: #312783 !important;
		background-color: rgb(49, 39, 131) !important; */
		height: 40px;
		padding: 10px 20px 10px 20px; /*This is tied into the page content paggind of 20px*/
		line-height: 50px;
		color: #fff;
		background: #312783; /* Old Browsers */
		background: -webkit-linear-gradient(bottom left,#312783,#6e689b); /*Safari 5.1-6*/
		background: -o-linear-gradient(bottom left,#312783,#6e689b); /*Opera 11.1-12*/
		background: -moz-linear-gradient(bottom left,#312783,#6e689b); /*Fx 3.6-15*/
		background: linear-gradient(bottom left, #312783, #6e689b); /*Standard*/	
	}

	.app-logo {
	  height:35px;
	  width:auto;
	}

	.avatar-menu {
		float:right;
	}

	.user-avatar {
		border:2px solid #fff;
	}

	.current-time {
		float:right;
		display:block;
		height: 60px;
		width:300px;
		text-align: right;
		line-height: 40px;
		padding-right:20px;
	}


</style>


// WEBPACK FOOTER //
// src/components/Header.vue